<template>
  <lazy-div :load="doInit">
    <v-card>
      <v-toolbar v-if="newGSTMap" dense color="grey lighten-3" flat>
        <v-icon>mdi-plus </v-icon>
        <v-toolbar-title>Create New GST Mapping </v-toolbar-title>
      </v-toolbar>
      <v-toolbar v-if="!newGSTMap" dense color="grey lighten-3" flat>
        <v-icon>mdi-pencil </v-icon>
        <v-toolbar-title>Edit GST Mapping </v-toolbar-title>
      </v-toolbar>
      <!-- <v-card-title>
        <div class="headline" v-if="newGSTMap">New GST Mapping</div>
        <div class="headline" v-else>Review GST Mapping</div>
      </v-card-title> -->
      <v-card-text>
        <v-flex xs12 class="mt-1">
          <message :messages="messages"></message>
        </v-flex>
        <v-container fluid grid-list-md>
          <v-layout row>
            <v-flex xs6 v-if="newGSTMap">
              <v-autocomplete
                :items="gstApplnIntList"
                v-model="gstMapForm.gstApplnInt"
                :label="labels.gstApplnInt"
                item-text="label"
                item-value="value"
                data-vv-name="gstApplnInt"
                :data-vv-as="labels.gstApplnInt"
                :error-messages="errors.collect('gstApplnInt')"
                v-validate="'required'"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.gstApplnInt }}</v-subheader>
              <div class="queryValue">{{ gstMapForm.gstApplnInt }} - {{ gstMapForm.gstApplnIntDesc }}</div>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs6>
              <v-checkbox :label="labels.sepStatCtyRisk" v-model="gstMapForm.sepStatCtyRisk"></v-checkbox>
            </v-flex>
            <v-flex xs6>
              <v-checkbox :label="labels.sepStatBrn" v-model="gstMapForm.sepStatBrn"></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs6>
              <v-checkbox :label="labels.sepStatDri" v-model="gstMapForm.sepStatDri"></v-checkbox>
            </v-flex>
            <v-flex xs6>
              <v-checkbox :label="labels.sepStatRegStat" v-model="gstMapForm.sepStatRegStat"></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs6>
              <v-checkbox :label="labels.sepStatCtyAgt" v-model="gstMapForm.sepStatCtyAgt"></v-checkbox>
            </v-flex>
            <v-flex xs6>
              <v-checkbox :label="labels.sepStatCtyCed" v-model="gstMapForm.sepStatCtyCed"></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs6>
              <v-checkbox :label="labels.sepStatCtyRi" v-model="gstMapForm.sepStatCtyRi"></v-checkbox>
            </v-flex>
          </v-layout>
          <v-divider horizontal></v-divider>
          <v-layout row>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ gstMapForm.createdBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ gstMapForm.createdDate | formatDate }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="!newGSTMap">
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              <div class="queryValue">{{ gstMapForm.modifiedBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ gstMapForm.modifiedDate | formatDate }}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
        <span>Cancel</span>
        <v-icon right dark>mdi-cancel</v-icon>
      </v-btn>
      <v-btn color="primary" dark class=" mr-2" @click="doSave" :loading="submitting">
        Save GST Mapping
        <v-icon right>mdi-content-save</v-icon>
      </v-btn>
    </v-card>
  </lazy-div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { gstApplnInt } from '@/const/acct/gst'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      labels: {
        gstApplnInt: 'GST Application Interface',
        sepStatCtyRisk: 'Country of Risk',
        sepStatBrn: 'Branch',
        sepStatDri: 'Direct / RI Inward',
        sepStatRegStat: 'Agent GST Reg Status',
        sepStatCtyAgt: 'Country of Agent',
        sepStatCtyCed: 'Country of Cedant',
        sepStatCtyRi: 'Country of Reinsurer',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      gstMapForm: {
        gstApplnInt: null,
        gstApplnIntDesc: null,
        sepStatCtyRisk: null,
        sepStatBrn: null,
        sepStatDri: null,
        sepStatRegStat: null,
        sepStatCtyAgt: null,
        sepStatCtyCed: null,
        sepStatCtyRi: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      submitting: false
    }
  },
  methods: {
    async doInit() {
      if (!this.newGSTMap) {
        const apiURI = this.menu.getGSTMap
        if (apiURI) {
          try {
            const expand = {
              gstApplnInt: this.gstApplnInt
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.gstMapForm.gstApplnInt = data.gstMap.gstApplnInt
              this.gstMapForm.gstApplnIntDesc = gstApplnInt[data.gstMap.gstApplnInt]
              this.gstMapForm.sepStatCtyRisk = data.gstMap.sepStatCtyRisk
              this.gstMapForm.sepStatBrn = data.gstMap.sepStatBrn
              this.gstMapForm.sepStatDri = data.gstMap.sepStatDri
              this.gstMapForm.sepStatRegStat = data.gstMap.sepStatRegStat
              this.gstMapForm.sepStatCtyAgt = data.gstMap.sepStatCtyAgt
              this.gstMapForm.sepStatCtyCed = data.gstMap.sepStatCtyCed
              this.gstMapForm.sepStatCtyRi = data.gstMap.sepStatCtyRi
              this.gstMapForm.createdBy = data.createdBy
              this.gstMapForm.createdDate = data.createdDate
              this.gstMapForm.modifiedBy = data.modifiedBy
              this.gstMapForm.modifiedDate = data.modifiedDate
              this.$store.commit('GSTMAP_COMMIT_KEY', this.gstMapForm)
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        }
      } else {
        this.gstMapForm.gstApplnInt = null
        this.gstMapForm.gstApplnIntDesc = null
        this.gstMapForm.sepStatCtyRisk = false
        this.gstMapForm.sepStatBrn = false
        this.gstMapForm.sepStatDri = false
        this.gstMapForm.sepStatRegStat = false
        this.gstMapForm.sepStatCtyAgt = false
        this.gstMapForm.sepStatCtyCed = false
        this.gstMapForm.sepStatCtyRi = false
        this.gstMapForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
        this.gstMapForm.createdDate = new Date()
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitting = true
          const config = {
            method: this.newGSTMap ? 'post' : 'put',
            url: this.newGSTMap ? this.menu.createGSTMap : this.menu.updateGSTMap,
            data: this.gstMapForm
          }
          if (config.url) {
            this.$http
              .request(config)
              .then((result) => {
                const { data } = result
                this.notify(data)
                this.$store.commit('GSTMAP_COMMIT_KEY', this.gstMapForm)
                if (this.newGSTMap) {
                  this.$router.push({
                    name: 'gstMapReviewDet',
                    params: {
                      gstApplnInt: this.gstMapForm.gstApplnInt
                    }
                  })
                } else {
                  this.doInit()
                }
                this.submitting = false
              })
              .catch((err) => {
                this.submitting = false
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        }
      })
    },
    doCancel() {
      this.$router.push({ name: 'gstMap' })
    }
  },
  computed: {
    menu() {
      return this.$store.state.gstParam.menu
    },
    newGSTMap() {
      return this.gstApplnInt === 'new'
    },
    gstApplnIntList() {
      let result = []
      Object.keys(gstApplnInt).forEach(function (key) {
        const status = gstApplnInt[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  watch: {
    gstApplnInt(value) {
      this.doInit()
    }
  },
  filters: {
    formatDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return null
      }
    }
  },
  mixins: [MessageMixin],
  props: ['gstApplnInt']
}
</script>

<style>
</style>
